import cn from 'classnames'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { WELCOME_FLOW_TRANSLATION_KEYS as KEYS } from 'partner360/features/welcomeFlow/configs/translations'
import { selectWelcomeFlowUserData } from 'partner360/features/welcomeFlow/model/selectors'
import { IWelcomeFlowPartner } from 'partner360/features/welcomeFlow/model/types'

import styles from './MyPartnersSummary.module.scss'

interface IMyPartnersSummaryProps {
  partners: IWelcomeFlowPartner[]
}

/** The Welcome Flow's bindings summary as a tile: countries and region, partners total, role and
 *  BU. The region is the first partner's, as in the wizard. */
export const MyPartnersSummary = ({ partners }: IMyPartnersSummaryProps) => {
  const userData = useSelector(selectWelcomeFlowUserData)
  const countriesCount = useMemo(
    () => new Set(partners.map((partner) => partner.Country)).size,
    [partners]
  )
  const region = partners[0]?.GeoRegion ?? ''

  return (
    <div className={styles.root}>
      <div className={cn(styles.group, styles.scope)}>
        <Translation
          text={KEYS.partnerScopeInfo.statsCountries}
          replaceParams={[{ key: '{count}', value: `<span>${countriesCount}</span>` }]}
        />
        <Translation
          text={KEYS.partnerScopeInfo.statsRegion}
          replaceParams={[{ key: '{region}', value: `<span>${region}</span>` }]}
        />
      </div>

      <div className={styles.group}>
        <div className={styles.label}>
          <Translation text={KEYS.bindingsSummary.partnersTotalLabel} />
        </div>
        <div className={styles.value}>{partners.length}</div>
      </div>

      <div className={styles.group}>
        <div className={styles.row}>
          <div className={styles.label}>
            <Translation text={KEYS.bindingsSummary.roleLabel} />
          </div>
          <div className={styles.rowValue}>{userData.Roles}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>
            <Translation text={KEYS.bindingsSummary.buLabel} />
          </div>
          <div className={styles.rowValue}>{userData.BusinessUnit}</div>
        </div>
      </div>
    </div>
  )
}

MyPartnersSummary.displayName = 'MyPartnersSummary'
